import { render } from "./Linearization.vue?vue&type=template&id=1a085889"
import script from "./Linearization.vue?vue&type=script&lang=js"
export * from "./Linearization.vue?vue&type=script&lang=js"

import "./Linearization.vue?vue&type=style&index=0&id=1a085889&language=sass&lang=css"
script.render = render

export default script